interface PrizeModalProps {
  isOpen: boolean;
  prize: string;
  onClose: () => void;
}

export default function PrizeModal({ isOpen, prize, onClose }: PrizeModalProps) {
  if (!isOpen) return null;

  const handleTelegramClick = () => {
    window.open('https://t.me/myidbot', '_blank');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fadeIn">
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 md:p-8 animate-scaleIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i className="ri-close-line text-2xl"></i>
        </button>

        <div className="text-center">
          <div className="mb-4 md:mb-6">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full mb-4 animate-bounce">
              <i className="ri-trophy-line text-4xl md:text-5xl text-white"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              Поздравляем!
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-4">
              Вы выиграли
            </p>
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-full text-xl md:text-2xl font-bold shadow-lg">
              <span className="text-2xl md:text-3xl">⭐</span>
              {prize}
            </div>
          </div>

          <div className="bg-blue-50 rounded-2xl p-4 md:p-6 mb-6">
            <p className="text-sm md:text-base text-gray-700 mb-4">
              Чтобы получить подарки, перейдите в бот для раздачи
            </p>
            <button
              onClick={handleTelegramClick}
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 md:py-4 rounded-xl font-bold text-base md:text-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <i className="ri-telegram-line text-xl md:text-2xl"></i>
              Перейти в бота Telegram
            </button>
          </div>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-sm md:text-base font-medium transition-colors whitespace-nowrap"
          >
            Закрыть
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }

        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
